import type { FC, ReactNode } from "react";
import {
  type ClassNameProp,
  Icon,
  type IconProps,
  Tooltip,
} from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { infoIconStyle } from "./InfoIcon.css";

export type InfoIconProps = ClassNameProp & {
  value?: ReactNode | string;
  size?: IconProps["size"];
};

export const InfoIcon: FC<InfoIconProps> = ({
  className,
  value,
  size = "s",
}) => (
  <Tooltip value={value} click>
    <Icon
      icon="infoFilled"
      color="currentColor50"
      className={mergeClasses(infoIconStyle, className)}
      size={size}
    />
  </Tooltip>
);
